import type {
  AssetTypeSelectOptionItemData,
  AssetTypeSelectOptionItemValue,
  AssetTypeSelectProps,
} from "./asset-type-select.type";

import { useTranslation } from "react-i18next";

import QueryableSelect from "@/modules/queryable-select";

import { AssetTypeSelectOption } from "./asset-type-select-option";

export const AssetTypeSelect = ({
  label,
  hideLabel,
  ...props
}: AssetTypeSelectProps) => {
  const { t } = useTranslation();
  const text = label ?? t("global:assetType");

  return (
    <QueryableSelect<
      AssetTypeSelectOptionItemValue,
      AssetTypeSelectOptionItemData
    >
      name="asset_type"
      model="assetTypes"
      filterBy="name"
      fields={["id", "name"]}
      label={hideLabel ? undefined : text}
      placeholder={text}
      optionFormat={AssetTypeSelectOption}
      data-testid="asset-type-select"
      {...props}
    />
  );
};
